import i18next from 'i18next'
import * as React from 'react'
import {
  any,
  async,
  AsyncState,
  fromJSX,
  IOWidget,
  Updater,
  Widget,
} from 'widgets-for-react'
import { UserSubscriptions } from '../../../../subscription/subscriptionState'
import { generateBreadcrumbs } from '../../../../utils/breadcrumbs'
import { camelize } from '../../../../utils/utils'
import { TextPageHeader } from '../../pageHeader/pageHeaderLayout'
import { paywallWidget } from '../../paywall/paywallWidget'
import { RootLayout } from '../../rootLayout'
import { KnowledgeTeasersData } from '../knowledgeTeasers/knowledgeTeasersState'
import { KnowledgeTypeOverviewLayout } from './knowledgeTypeOverviewLayout'
import {
  KnowledgeTypeOverviewState,
  knowledgeTypeOverviewStateUpdaters,
} from './knowledgeTypeOverviewState'

export const knowledgeTypeOverviewWidget =
  (
    isLoggedIn: boolean,
    userSubscriptionsState: AsyncState<UserSubscriptions>
  ): IOWidget<
    KnowledgeTypeOverviewState,
    Updater<KnowledgeTypeOverviewState>
  > =>
  (knowledgeTypeOverviewState) => {
    const { knowledgeTypeOverviewData } = knowledgeTypeOverviewState
    return any([
      async(knowledgeTypeOverviewData).map(
        knowledgeTypeOverviewStateUpdaters.knowledgeTypeOverviewDataUpdater
      ),
      knowledgeTypeOverviewData.kind === 'loaded' &&
      knowledgeTypeOverviewData.value.length > 0
        ? any([
            fromJSX(() => (
              <TextPageHeader
                title={i18next.t(
                  `knowledge:${camelize(
                    knowledgeTypeOverviewData.value[0].KnowledgeType
                  )}Title`
                )}
                intro={i18next.t(
                  `knowledge:${camelize(
                    knowledgeTypeOverviewData.value[0].KnowledgeType
                  )}IntroOverview`
                )}
                breadcrumbs={generateBreadcrumbs()}
              />
            )),
            paywallWidget(isLoggedIn, userSubscriptionsState)(
              knowledgeTypeOverviewBaseWidget(
                knowledgeTypeOverviewData.value,
                true
              ),
              knowledgeTypeOverviewBaseWidget(
                knowledgeTypeOverviewData.value,
                false
              )
            ),
          ])
        : knowledgeTypeOverviewData.kind === 'loading'
        ? fromJSX(() => <RootLayout.Loader hasWrapper={true} showText={true} />)
        : fromJSX(() => <RootLayout.Error />),
    ])
  }

export const knowledgeTypeOverviewBaseWidget = (
  knowledgeTypeOverviewData: KnowledgeTeasersData,
  paywalled: boolean
): Widget<Updater<KnowledgeTypeOverviewState>> =>
  fromJSX(() => (
    <KnowledgeTypeOverviewLayout
      teasers={knowledgeTypeOverviewData}
      paywalled={paywalled}
    />
  ))
